<template>
  <div class="card editable-card">
    <div style="display: flex;">
      <div class="links-body">
        <div class="statBlock">
          <div class="card-header" v-if="$slots.header">
            <slot name="header"></slot>
          </div>
          <div class="card-body">
            <div class="headerrow">
              <div v-if="isFileUpload">Type</div>
              <div>Name</div>
              <div>URL</div>
            </div>
            <div
              style="height: 40px;"
              v-for="(link,index) in localLinks"
              :key="index"
              class="urlrow"
            >
              <input
                style="margin-right: 0;"
                v-if="isFileUpload && !isNewRow(link)"
                readonly
                :value="link.link_type"
              />
              <div v-if="isFileUpload && isNewRow(link)">
                <el-select
                  v-if="isFileUpload"
                  v-model="link.link_type"
                  class="select-primary link-dd"
                  size="xs-small"
                  placeholder="Type"
                >
                  <el-option
                    v-for="option in vals.LINK_TYPES"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option"
                  ></el-option>
                </el-select>
              </div>
              <input v-model="link.name" placeholder="Name" />
              <input
                v-if="(!isFileUpload || link.link_type=='URL')&&link.url_linkedin"
                v-model="link.url_linkedin"
                placeholder="URL"
              />
              <input
                v-if="(!isFileUpload || link.link_type=='URL')&&!link.url_linkedin"
                v-model="link.url"
                placeholder="URL"
              />
              <input
                type="button"
                v-on:click="handleDownloadClick(link)"
                v-else-if="isFileUpload && isLinkTypeFile(link) && !isNewRow(link)"
                value="Download"
              />

              <input
                v-if="isFileUpload && isLinkTypeFile(link) && isNewRow(link)"
                v-on:change="handleFileChange(link,$event)"
                type="file"
              />

              <input type="hidden" id="linkid" :value="link.upid" />
              <a @click="remove(index)" class="deleterowbutton">
                <i class="fa fa-minus-square fa-2x delete-row" aria-hidden="true"></i>
                <span>Remove Entry</span>
              </a>
            </div>
            <a @click="add" class="addrowbutton">
              <i class="fa fa-plus-square fa-2x" aria-hidden="true"></i>
              <span>Add Row</span>
            </a>
            <div v-if="isModal" class="actionbuttons">
              <button @click="cancel" class="btn btn-info btn-fill btn-wd">Cancel</button>
              <button @click="save" class="btn btn-info btn-fill btn-wd">Save</button>
            </div>
          </div>
          <div class="card-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Card from "../Card.vue";
import { mapGetters } from "vuex";
import { vals } from "../../../util";
import { Select, Option } from "element-ui";

const FILE_UPLOAD = "fileupload";
const LINK_TYPE_FILE = "File";
const LINK_TYPE_URL = "URL";

export default {
  name: "edit-links-card",
  components: {
    Card,
    [Option.name]: Option,
    [Select.name]: Select
  },
  computed: {
    ...mapGetters("people", ["nextId"]),
    isFileUpload() {
      return this.context == FILE_UPLOAD || this.context == "document";
    },
    isLinkTypeFile(link) {
      return function(link) {
        return link.link_type == LINK_TYPE_FILE;
      };
    },
    isNewRow(link) {
      return function(link) {
        return !!!link._id;
      };
    }
  },
  props: ["links", "context", "isModal"],
  data() {
    return {
      vals: vals,
      localLinks: _.without(_.concat([], this.links), null, undefined),
      deleted: [],
      next_id: 0
    };
  },
  methods: {
    save() {
      // call here when user clicks 'save'
      // compile into 'added', 'updated', and 'deleted'
      let e = {
        added: [],
        updated: [],
        deleted: this.deleted,
        local: this.localLinks
      };
      e.added = _.map(this.localLinks, l => {
        if (!_.isNil(l.id)) return l;
        return null;
      });
      e.updated = _.map(this.localLinks, l => {
        if (!_.isNil(l._id)) return l;
        return null;
      });
      e.added = _.without(e.added, null, undefined);
      e.updated = _.without(e.updated, null, undefined);
      this.$emit("edit-links-card-close", this.context, {
        data: e,
        confirm: true
      });
    },
    cancel() {
      // call here when user clicks cancel
      this.$emit("edit-links-card-close", this.context, { confirm: false });
    },
    add() {
      // add a new link
      let l = {
        name: undefined,
        link_type: vals.LINK_TYPE_DEFAULT,
        fileBlob: undefined,
        url: undefined,
        id: this.next_id++
      };
      this.localLinks.push(l);
      if (!this.isModal)
        this.$emit("edit-links-card-add", this.context, { link: l });
    },
    remove(i) {
      let item = _.first(_.pullAt(this.localLinks, i));
      if (!_.isNil(item.upid || item.uaid)) {
        this.deleted.push(item.upid || item.uaid);
        if (!this.isModal)
          this.$emit("edit-links-card-remove", this.context, {
            uid: item.upid || item.uaid || item._id
          });
      } else if (!this.isModal) {
        // make sure to remove new entry (the new id)
        this.$emit("edit-links-card-remove", this.context, {
          id: item.id || item._id
        });
      }
      this.localLinks = _.concat(this.localLinks, []); // forces refresh
    },

    handleFileChange(link, e) {
      link.fileBlob = e.target.files[0];
    },
    handleDownloadClick(link) {
      this.$emit("edit-links-card-download", this.context, {
        id: link.s3_path
      });
    }
  },
  mounted() {
    if (_.isNil(this.localLinks) || _.isEmpty(this.localLinks)) this.add();
    this.localLinks = _.without(this.localLinks, null, undefined);
  },
  watch: {
    links: {
      handler(newLinks) {
        this.localLinks = _.without(_.concat([], newLinks), null, undefined);
      }
    },
    localLinks: {
      handler(newLinks) {
        if (!this.isModal)
          this.$emit("edit-links-card-update", this.context, {
            updated: newLinks
          });
      },
      deep: true
    }
  }
};
</script>
<style lang="scss">
/*.edit-button {
    display: block !important;
    width: calc(100% - 10px);
    text-align: center;
    border-top: 1px solid #dfdfdf;
    font-size: 0.8em;
    margin-bottom: 5px;
    margin-left: 5px;
    margin-top: 30px;
}

.links-body {
    width: 100% !important;
}*/

.headerrow {
  display: flex;
}

.headerrow div {
  width: calc(50% - 10px);
}

@media screen and (max-width: 740px) {
  .headerrow {
    display: none;
  }
}

.delete-row {
  color: #e04b4b;
  padding-left: 4px;
}

.deleterowbutton span {
  display: none;
}

@media screen and (max-width: 740px) {
  .deleterowbutton {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
  }

  .deleterowbutton span {
    display: block;
    margin-left: 14px;
    color: #e04b4b !important;
  }
}

.urlrow {
  display: flex;
  margin-bottom: 5px;
  align-items: center;
}

.urlrow input {
  padding: 4px;
  width: calc(50% - 18px);
}

.urlrow input:first-child {
  margin-right: 4px;
}

.addrowbutton {
  display: flex;
  align-items: center;
}

.addrowbutton span {
  margin-left: 12px;
}

@media screen and (max-width: 740px) {
  .urlrow {
    flex-direction: column;
  }

  .urlrow input:first-child {
    margin-right: 0px;
  }

  .urlrow input {
    padding: 4px;
    width: 100%;
    margin-bottom: 4px;
  }
}

.actionbuttons {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.actionbuttons button:first-child {
  margin-right: 10px;
}

@media screen and (max-width: 740px) {
  .actionbuttons {
    flex-direction: column;
  }

  .actionbuttons button:first-child {
    margin-right: 0px;
  }
}

.link-dd.select-primary.el-select {
  .el-input input {
    border-radius: 0;
    margin-right: 2px;
    height: 32px;
    border: 1px solid #dfdfdf !important;
    margin: 0;
    padding: 4px;
  }
}
</style>